import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { IonModal } from '@ionic/angular';

@Component({
    selector: 'app-select-exercise',
    templateUrl: './select-exercise.component.html',
    styleUrls: ['./select-exercise.component.scss'],
    standalone: false
})
export class SelectExerciseComponent implements OnInit {
  presentingElement: Element | null = null;
  @ViewChild('modal') modal!: IonModal;
  @Output() exerciseAdded = new EventEmitter<string>(); // Use <any> or a specific type for the event payload
  @Output() closeView = new EventEmitter<any>();
  @Output() exercisesEmitted = new EventEmitter<string[]>();
  @Output() updateSwiper = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {
    this.presentingElement = document.querySelector('.ion-tabs');
  }

  updateS() {
    setTimeout(() => this.updateSwiper.emit(), 1000);
  }
}
